import { hasHidden, valueOrNull } from "@/shared/value";
import { useQuery } from "@apollo/client";
import { GET_COMPANY_DOCUMENT_BY_ID } from "../api/get-company-document-by-id";
import { useEditMode } from "@/shared/form/form";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";
import { FieldsType } from "./types";
import { CompanyDocumentReadConfirmationType } from "gql/graphql";

export function useCompanyDocumentEntity({
  id,
  folderId,
}: {
  id?: string;
  folderId?: string;
}) {
  const { formKey, onEntityLoaded } = useEditMode();
  const { data, loading } = useQuery(GET_COMPANY_DOCUMENT_BY_ID, {
    variables: { id: id as string },
    skip: !id,
    onCompleted: onEntityLoaded,
  });

  const document = data?.getCompanyDocumentById;

  const entity: Partial<FieldsType> = document
    ? {
        id: document.id,
        name: extractLocalizedValue(document.name),
        description: extractLocalizedValue(document.description),
        file: document.file.id as string,
        isActive: document.isActive,
        isAssignToNewPersons: document.isAssignToNewPersons,
        readConfirmationType: document.readConfirmationType,
        folderId: valueOrNull(document.folder)?.id,
      }
    : {
        isActive: true,
        isAssignToNewPersons: true,
        readConfirmationType: CompanyDocumentReadConfirmationType.NotRequired,
        folderId,
      };

  return {
    entity,
    loading,
    formKey,
    // `folderId` необязателен: скрытая папка станет `undefined`, и документ переедет
    // в корень дерева. Восстановить нечем — скрытая папка вырезана и из выбора.
    hasHiddenFields: hasHidden([document?.folder]),
    initialReadConfirmationType: document?.readConfirmationType,
    hasConfirmations: (document?.confirmationInfoCount.total ?? 0) > 0,
  };
}
